import { render } from "./WorkflowFooter.vue?vue&type=template&id=6a0964b4&ts=true"
import script from "./WorkflowFooter.vue?vue&type=script&lang=ts"
export * from "./WorkflowFooter.vue?vue&type=script&lang=ts"

import exportComponent from "/buddy/uup/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__